import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { persistExposureViewModeEpic } from './_epics/persistExposureViewMode.epic';

export const exposureDashboardEpic = safeCombineEpics(
  persistExposureViewModeEpic,
);
